<template>
  <div>
    <ChooseSchoolForForm
      v-if="styType == 1"
      ref="chooseSchool"
      v-model="selectSchoolData"
      :use-slot="true"
      @firstLoadData="getSchoolDefault"
      @postSchoolRow="getSelectSchoolRow"
    >
      <div class="info-line">
        <span>{{ selectSchoolName }}</span>
        <div
          v-if="showSwitchBtn"
          class="switch-block"
          @click="handleChangeSchool"
        >
          切换
        </div>
      </div>
    </ChooseSchoolForForm>
    <ChooseSchoolNewSty
      v-if="styType == 2"
      ref="chooseSchool"
      v-model="selectSchoolData"
      :use-slot="true"
      @firstLoadData="getSchoolDefault"
      @postSchoolRow="getSelectSchoolRow"
    >
      <div class="info-line">
        <span>{{ selectSchoolName }}</span>
        <div
          v-if="showSwitchBtn"
          class="switch-block"
          @click="handleChangeSchool"
        >
          切换
        </div>
      </div>
    </ChooseSchoolNewSty>
  </div>
</template>
<script>
import ChooseSchoolForForm from '@c/searchBlock/ChooseSchoolForForm';
import ChooseSchoolNewSty from '@c/searchBlock/ChooseSchoolNewSty';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
export default {
  components: {
    ChooseSchoolForForm,
    ChooseSchoolNewSty
  },
  props: {
    // 是否使用新样式
    styType: {
      type: [Number, String],
      default: 1
    },
    showSwitchBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectSchool: '', // 选中的学校id
      selectSchoolName: '',
      selectSchoolData: {},
      hasDefault: false
    };
  },
  computed: {
    ...mapState(['schoolIdForState', 'schoolNameForState'])
  },
  created() {
    if (this.schoolIdForState) {
      this.selectSchool = this.schoolIdForState;
      this.selectSchoolName = this.schoolNameForState;
      this.selectSchoolData = {
        name: this.selectSchoolName,
        id: this.selectSchool,
        orgId: this.selectSchool
      };
      this.hasDefault = true;
      this.$emit('changeSchool', this.selectSchool);
    } else {
      this.$nextTick(() => {
        this.$refs.chooseSchool.getSchoolListData();
      });
    }
    // if (localStorage.getItem('schoolId')) {
    //   this.selectSchool = localStorage.getItem('schoolId');
    //   this.selectSchoolName = localStorage.getItem('schoolName');
    //   this.selectSchoolData = {
    //     name: this.selectSchoolName,
    //     id: this.selectSchool,
    //     orgId: this.selectSchool
    //   };
    //   this.hasDefault = true;
    //   this.$emit('changeSchool', this.selectSchool);
    // } else {
    //   this.$nextTick(() => {
    //     this.$refs.chooseSchool.getSchoolListData();
    //   });
    // }
  },
  mounted() {
    this.$eventHub.$on('changeYearTermCode', yearTermCode => {
      this.$refs.chooseSchool.getSchoolListData();
    });
    this.$eventHub.$on('changeDefaultSchool', () => {
      console.log('重新拿到新的学校id');
      this.hasDefault = false;
      this.$refs.chooseSchool.firstGetData = false;
      this.$refs.chooseSchool.getSchoolListData();
    });
    this.$eventHub.$on('pushChangeSchool', schoolData => {
      this.getSelectSchoolRow(schoolData);
    });
  },
  destroyed() {
    this.$eventHub.$off('changeYearTermCode');
    this.$eventHub.$off('changeDefaultSchool');
    this.$eventHub.$off('pushChangeSchool');
    localStorage.removeItem('yearTermCode');
  },
  methods: {
    ...mapMutations(['SET_SELECTSCHOOL']),
    handleChangeSchool() {
      this.$refs.chooseSchool.handleOpenSchool();
    },
    getSchoolDefault(list) {
      if (this.hasDefault) {
        return;
      }
      if (list.length === 0) {
        this.selectSchool = null;
        this.selectSchoolName = '暂无学校';
        return;
      }
      this.selectSchool = list[0].id;
      this.selectSchoolName = list[0].name;
      this.SET_SELECTSCHOOL({ schoolId: this.selectSchool, schoolName: this.selectSchoolName });
      // localStorage.setItem('schoolId', this.selectSchool);
      // localStorage.setItem('schoolName', this.selectSchoolName);
      this.selectSchoolData = {
        name: this.selectSchoolName,
        id: this.selectSchool,
        orgId: this.selectSchool
      };
      this.hasDefault = true;
      this.$emit('changeSchool', this.selectSchool);
    },
    getSelectSchoolRow(row) {
      this.selectSchoolData = row;
      this.selectSchool = row.id;
      this.selectSchoolName = row.name;
      // localStorage.setItem('schoolId', this.selectSchool);
      // localStorage.setItem('schoolName', this.selectSchoolName);
      this.SET_SELECTSCHOOL({ schoolId: this.selectSchool, schoolName: this.selectSchoolName });
      this.$eventHub.$emit('changeSchool', row.id);
      this.$emit('changeSchool', this.selectSchool);
    }
  }
};
</script>
<style lang="scss" scoped>
.select-box-school {
  display: flex;
  // margin-bottom: 16px;
}
.info-line {
  display: flex;
  align-items: center;
  span {
    color: #488ffa;
    font-weight: 800;
  }
  .switch-block {
    padding: 4px 8px;
    border: 1px solid #dcdfe6;
    border-radius: 20px;
    margin-left: 10px;
    background: white;
    color: #242e3a;
    cursor: pointer;
    font-size: 14px;
  }
}
.search-line {
  margin-bottom: 16px;
  .search-input {
    width: 180px;
    margin-right: 16px;
  }
}
</style>
